// Libellés lisibles des clés de features_v2. Une clé absente est
// affichée sous une forme « humanisée » (voir humanizeKey) : on peut donc
// ajouter une option côté API sans toucher à ce fichier.

export const FEATURE_LABELS = {
  // features_v2 : sections
  AUTHENTICATION: 'Authentification',
  TOUR_PLANNING: 'Planification',
  TOUR_MANAGEMENT: 'Gestion de tournée',
  TOUR_START: 'Début de tournée',
  TOUR_STEP: 'Étapes',
  TOUR_END: 'Fin de tournée',
  CONSIGNMENT_PACKAGING: 'Palettes consignées',
  OTHERS: 'Autres',

  // features_v2 : options
  SELECT_DRIVER: 'Sélection du chauffeur',
  canCreateNewDriver: 'Peut créer un nouveau chauffeur',
  CAN_SELECT_TOUR_IF_MULTIPLE_TOUR_MATCHES:
    'Choix de la tournée si plusieurs correspondent',
  ORDERS_POOL: 'Puits de commandes',
  canDeleteOrders: 'Peut supprimer des commandes',
  TRUCK_ASSIGNMENTS: 'Affectations camion',
  DISPATCH: 'Répartition',
  VEHICLES_OF_THE_DAY: 'Véhicules du jour',
  VROOM_OPTIMIZATION: 'Optimisation VROOM',
  WAREHOUSES: 'Entrepôts',
  TOUR_START_NEEDED: 'Démarrage de tournée obligatoire',
  TOUR_END_NEEDED: 'Clôture de tournée obligatoire',
  WASHING: 'Lavage',
  timer: 'Minuteur',
  FUEL_CONSIGNMENT: 'Saisie carburant',
  TOUR_INFORMATION: 'Informations de tournée',
  TOUR_RESERVE: 'Réserves sur la tournée',
  CHAT: 'Messagerie',
  TRUCK_CONTAINERS: 'Compartiments du camion',
  CONTACT_BLOCK: 'Bloc contacts',
  from_database: 'Contacts issus de la base',
  SANITARY_RISK: 'Risque sanitaire',
  blockUserIfNotConfirmed: 'Bloquer si non confirmé',
  CONTEXTUAL_ACTIONS: 'Actions contextuelles',
  navigateToBase: 'Retour à la base',
  downloadDriverLetter: 'Télécharger la lettre de voiture',
  START_CHECKLIST: 'Checklist de départ',
  START_MILEAGE: 'Kilométrage de départ',
  MULTI_STEP: 'Multi-étapes',
  DISPLAY_ETA: 'Afficher l’heure estimée',
  DISPLAY_ITINERARY: 'Afficher l’itinéraire',
  DISPLAY_DISTANCE_FROM_STEP: 'Afficher la distance à l’étape',
  OPEN_EXTERNAL_NAVIGATION: 'Navigation externe (GPS)',
  STEP_FINISH: 'Clôture d’étape',
  STEP_ACTIONS: 'Actions sur l’étape',
  signingAttendance: 'Signature',
  mandatoryAttendance: 'Présence obligatoire',
  receivers: 'Réceptionnaires',
  cancel: 'Annulation',
  need_to_confirm: 'Confirmation requise',
  reasonAttendance: 'Motif d’annulation',
  CONTACT_RECEIVER: 'Contact du réceptionnaire',
  callReceiver: 'Appeler le réceptionnaire',
  ORDER_ACTIONS: 'Actions sur la commande',
  ADDRESS_ACTIONS: 'Actions sur l’adresse',
  ifProcessed: 'Si traitée',
  commentMandatoryOnProduct: 'Commentaire obligatoire sur produit',
  nbMaxPhotos: 'Nombre max. de photos',
  MILEAGE_CONSIGNATION: 'Relevé kilométrique',
  PALLETS_LEFT_RETAKEN: 'Palettes laissées / reprises',
  PICTURE_BEFORE_AFTER: 'Photos avant / après',
  STEP_PICTURE_LOCATION: 'Photo du lieu de livraison',
  ARRIVAL_DEPARTURE_TIME: 'Heures d’arrivée / de départ',
  END_PROCESS: 'Processus de fin',
  END_FUEL: 'Carburant',
  END_MILEAGE: 'Kilométrage de fin',
  END_WASHING: 'Lavage',
  skippable_if_done_during_tour: 'Ignorable si fait pendant la tournée',
  END_LEFT_GOODS: 'Marchandise restante',
  textInfoMessage: 'Message d’information',
  END_TRUCK_PICTURES: 'Photos du camion',
  END_ELECTRONIC_SIGNING: 'Signature électronique',
  UPLOAD: 'Import',
  canUploadTourWithExcel: 'Import de tournées Excel',
  tourCreationDateUsed: 'Utiliser la date de création',
  tourRequiresBackofficeValidation: 'Validation backoffice requise',
  INVOICE: 'Facturation',
  batchInvoiceGeneration: 'Génération des factures en lot',
  visibleToClient: 'Factures visibles par le client',
  BACKOFFICE: 'Backoffice',
  displayDeliveryDetails: 'Afficher les bons de livraison',
  tourNumberOnlyLastDigit: 'N° de tournée : derniers chiffres seulement',
  webFiltersAvailableIfAny: 'Filtres web disponibles',
  filters: 'Filtres',
  canDownloadDashboardResume: 'Téléchargement du résumé du tableau de bord',
  displayReceiversOnStepCard: 'Réceptionnaires sur la carte d’étape',
  displayProofPhotosInline: 'Photos de preuve en ligne',
  canCreateVehicleFromBackoffice: 'Création de véhicule depuis le backoffice',
  canSetStartingHourForTours: 'Heure de départ modifiable',
  canSetCleaningNeededForTours: 'Nettoyage requis modifiable',
  needToAssociateFactory: 'Usine de rattachement obligatoire',
  ADDRESSES: 'Destinataires',
  canExportXlsx: 'Export Excel',
  NOTIFICATION: 'Notifications',
  sendFixedHoursNotification: 'Notification à heure fixe',
  hours: 'Heure',
  EMAIL: 'Email',
  emailSender: 'Adresse d’expédition',
  emailSenderName: 'Nom d’expéditeur',

  // Clés génériques
  enabled: 'Activé',
  required: 'Obligatoire',
  textMessage: 'Message',
  textTitle: 'Titre',
  reserve: 'Réserve',
  name: 'Nom',
};

export const humanizeKey = (key) => {
  const words = key
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .trim()
    .toLowerCase();

  return words.charAt(0).toUpperCase() + words.slice(1);
};

export const getFeatureLabel = (key) => FEATURE_LABELS[key] || humanizeKey(key);
